import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import FiscalitationForm from '../Forms/FiscalitationForm';

const AddEditFiscalitation = ({
	dataFiscalizacion,
	isOpen,
	isEdit,
	handleToggleModal,
	handleSave,
	establishmentOptions,
	inspectionTypeOptions,
	inspectionAuthorityOptions,
	personOptions,
	managementPositionOptions,
	fiscalizerOptions,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Fiscalización
			</ModalHeader>

			<FiscalitationForm
				dataFiscalizacion={dataFiscalizacion}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				handleSave={handleSave}
				establishmentOptions={establishmentOptions}
				inspectionTypeOptions={inspectionTypeOptions}
				inspectionAuthorityOptions={inspectionAuthorityOptions}
				personOptions={personOptions}
				managementPositionOptions={managementPositionOptions}
				fiscalizerOptions={fiscalizerOptions}
			/>
		</Modal>
	);
};

export default AddEditFiscalitation;
